import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ListingSection from '../ListingSection';
import { textMaxWidthSx } from '../listingPageStyles';
import ListingSectionItem from '../ListingSectionItem';

/**
 * SectionDescriptionMaybe renders the description section of the listing page.
 * It formats the description text and displays it if available.
 *
 * @param {string} description - The text description of the listing.
 * @param {boolean} isTranslated - Indicates if the description has been translated.
 * @param listingIsLoading - State from ListingPageComponent.js.
 * @returns A React component that displays the description section or null if there's no description.
 */
const SectionDescriptionMaybe = ({ description, isTranslated }) => {
  if (!description) return null;
  return (
    <ListingSection>
      <ListingSectionItem
        params={{
          sx: { justifyContent: { xs: 'center', sm: 'flex-start' } },
        }}
      >
        <Typography component="h3" mb={2} variant="h4">
          <FormattedMessage id="ListingPage.descriptionTitle" />
        </Typography>
      </ListingSectionItem>
      <ListingSectionItem params={{ sx: textMaxWidthSx }}>
        <Typography sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }} variant="body1">
          {description}
        </Typography>
      </ListingSectionItem>
      {isTranslated ? (
        <ListingSectionItem params={{ sx: textMaxWidthSx }}>
          <Typography variant="small">
            <FormattedMessage id="ListingPage.description.translation" />
          </Typography>
        </ListingSectionItem>
      ) : null}
    </ListingSection>
  );
};

export default React.memo(SectionDescriptionMaybe);
